document.addEventListener("DOMContentLoaded",()=>{
  const loader=document.querySelector("#bona-loader");
  window.setTimeout(()=>loader?.classList.add("is-hidden"),700);

  const menu=document.querySelector("[data-menu]");
  const menuToggle=document.querySelector("[data-menu-toggle]");
  const menuClose=document.querySelector("[data-menu-close]");
  menuToggle?.addEventListener("click",()=>{
    menu?.classList.add("is-open");
    menuToggle.setAttribute("aria-expanded","true");
  });
  menuClose?.addEventListener("click",()=>{
    menu?.classList.remove("is-open");
    menuToggle?.setAttribute("aria-expanded","false");
  });
  document.querySelectorAll("[data-menu] nav a").forEach(link=>link.addEventListener("click",()=>{
    menu?.classList.remove("is-open");
    menuToggle?.setAttribute("aria-expanded","false");
  }));

  const drawer=document.querySelector("[data-cart-drawer]");
  const routes=window.Bona5ideRoutes||{};
  document.querySelector("[data-cart-close]")?.addEventListener("click",()=>{drawer?.classList.remove("is-open");drawer?.setAttribute("aria-hidden","true");});
  document.addEventListener("keydown",event=>{
    if(event.key==="Escape"){
      menu?.classList.remove("is-open");
      drawer?.classList.remove("is-open");
      drawer?.setAttribute("aria-hidden","true");
      menuToggle?.setAttribute("aria-expanded","false");
    }
  });

  async function getCart(){
    const response=await fetch(routes.cartJs||"/cart.js",{headers:{Accept:"application/json"}});
    if(!response.ok) throw new Error("Unable to load cart");
    return response.json();
  }

  async function openCart(){
    const cart=await getCart();
    document.querySelectorAll("[data-cart-count]").forEach(el=>el.textContent=cart.item_count);
    document.querySelectorAll("[data-cart-drawer-count]").forEach(el=>el.textContent=cart.item_count);
    document.querySelectorAll("[data-cart-drawer-total]").forEach(el=>el.textContent=(cart.total_price/100).toLocaleString(undefined,{style:'currency',currency:'USD'}));
    const target=document.querySelector("[data-cart-drawer-items]");
    if(target){
      target.innerHTML=cart.items.length
        ? cart.items.map(item=>`<div class="cart-item"><img src="${item.image||''}" alt=""><div><strong>${item.product_title}</strong><small>${item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:''}</small><span class="cart-line-price">${(item.final_line_price/100).toLocaleString(undefined,{style:'currency',currency:'USD'})} × ${item.quantity}</span></div></div>`).join("")
        : "YOUR BAG IS EMPTY.";
    }
    drawer?.classList.add("is-open");
    drawer?.setAttribute("aria-hidden","false");
  }

  document.addEventListener("submit",async event=>{
    const form=event.target.closest("form[action*='/cart/add']");
    if(!form) return;
    event.preventDefault();
    const btn=form.querySelector("[type=submit]");
    const old=btn?.textContent;
    if(btn){btn.disabled=true;btn.textContent="ADDING...";}
    try{
      const response=await fetch(routes.cartAdd||"/cart/add.js",{
        method:"POST",
        body:new FormData(form),
        headers:{Accept:"application/json"}
      });
      if(!response.ok) throw new Error("Unable to add item");
      await openCart();
    }catch(error){
      if(btn){btn.textContent="TRY AGAIN";}
    }finally{
      if(btn) window.setTimeout(()=>{btn.disabled=false;btn.textContent=old||"ADD TO BAG →";},1100);
    }
  });


  // Product gallery slideshow
  document.querySelectorAll("[data-product-gallery]").forEach(gallery=>{
    const slides=[...gallery.querySelectorAll(".product-slide")];
    if(!slides.length) return;
    let current=slides.findIndex(s=>s.classList.contains("is-active"));
    if(current<0) current=0;
    const counter=gallery.querySelector("[data-gallery-current]");
    const show=(index)=>{
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>slide.classList.toggle("is-active",i===current));
      if(counter) counter.textContent=current+1;
    };
    gallery.querySelector("[data-gallery-prev]")?.addEventListener("click",()=>show(current-1));
    gallery.querySelector("[data-gallery-next]")?.addEventListener("click",()=>show(current+1));
    gallery.addEventListener("keydown",e=>{
      if(e.key==="ArrowLeft") show(current-1);
      if(e.key==="ArrowRight") show(current+1);
    });
    gallery.tabIndex=0;
  });

  // Product variant buttons + live price/availability
 // Product variant buttons + live price/availability
document.querySelectorAll("[data-product-form]").forEach(form => {

  // Product page
  const page = form.closest("[data-product-page]");

  if (!page) return;

  /*
   * IMPORTANT:
   * data-product-variants is OUTSIDE the product-page section,
   * so we must search the document, NOT page.querySelector()
   */
  const variantsEl = document.querySelector("[data-product-variants]");

  if (!variantsEl) {
    console.error("Product variants JSON not found.");
    return;
  }

  let variants = [];

  try {
    variants = JSON.parse(variantsEl.textContent || "[]");
  } catch (error) {
    console.error("Could not parse product variants:", error);
    return;
  }

  if (!variants.length) {
    console.error("No product variants found.");
    return;
  }

  const groups = [
    ...form.querySelectorAll("[data-option-group]")
  ];

  const hiddenId = form.querySelector("[data-variant-id]");
  const priceEl = page.querySelector("[data-product-price]");
  const statusEl = form.querySelector("[data-variant-status]");
  const addBtn = form.querySelector("[data-add-to-bag]");

  /*
   * Money
   */
  const money = cents => {
    try {
      return (Number(cents) / 100).toLocaleString(undefined, {
        style: "currency",
        currency: "USD"
      });
    } catch (error) {
      return "$" + (Number(cents) / 100).toFixed(2);
    }
  };

  /*
   * Get variant options
   *
   * Shopify normally gives:
   * variant.options = ["Black", "M"]
   *
   * We also support option1/option2/option3.
   */
  const getVariantOptions = variant => {

    if (
      Array.isArray(variant.options) &&
      variant.options.length
    ) {
      return variant.options;
    }

    return [
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(value =>
      value !== null &&
      value !== undefined
    );
  };

  /*
   * -------------------------------------------------------
   * Current variant
   * -------------------------------------------------------
   */

  const initialVariantId = hiddenId?.value;

  let currentVariant =
    variants.find(
      variant =>
        String(variant.id) === String(initialVariantId)
    ) ||
    variants.find(variant => variant.available) ||
    variants[0];

  /*
   * Selected options
   *
   * Example:
   * ["Black", "M"]
   */
  let selectedOptions =
    getVariantOptions(currentVariant).slice();

  /*
   * Make sure array matches number of option groups
   */
  while (selectedOptions.length < groups.length) {
    selectedOptions.push("");
  }

  /*
   * -------------------------------------------------------
   * Highlight selected buttons
   * -------------------------------------------------------
   */

  const syncButtons = () => {

    groups.forEach(group => {

      const optionIndex =
        Number(group.dataset.optionIndex);

      group
        .querySelectorAll("[data-option-value]")
        .forEach(button => {

          const buttonValue =
            button.dataset.optionValue;

          const selected =
            String(buttonValue) ===
            String(selectedOptions[optionIndex]);

          button.setAttribute(
            "aria-pressed",
            selected ? "true" : "false"
          );

          /*
           * Add visual classes
           */
          button.classList.toggle(
            "is-selected",
            selected
          );

          button.classList.toggle(
            "selected",
            selected
          );
        });
    });
  };

  /*
   * -------------------------------------------------------
   * Find exact variant
   * -------------------------------------------------------
   */

  const findVariant = () => {

    /*
     * Need all options selected
     */
    if (
      selectedOptions.length !== groups.length ||
      selectedOptions.some(
        value =>
          value === null ||
          value === undefined ||
          value === ""
      )
    ) {
      return null;
    }

    return variants.find(variant => {

      const options =
        getVariantOptions(variant);

      if (options.length !== groups.length) {
        return false;
      }

      return options.every(
        (optionValue, index) =>
          String(optionValue) ===
          String(selectedOptions[index])
      );

    }) || null;
  };

  /*
   * -------------------------------------------------------
   * Check option availability
   * -------------------------------------------------------
   */

  const isOptionAvailable = (
    optionIndex,
    optionValue
  ) => {

    return variants.some(variant => {

      if (!variant.available) {
        return false;
      }

      const options =
        getVariantOptions(variant);

      /*
       * Current button must match
       */
      if (
        String(options[optionIndex]) !==
        String(optionValue)
      ) {
        return false;
      }

      /*
       * Other selected options must match
       */
      return options.every(
        (value, index) => {

          if (index === optionIndex) {
            return true;
          }

          const selected =
            selectedOptions[index];

          if (
            selected === null ||
            selected === undefined ||
            selected === ""
          ) {
            return true;
          }

          return (
            String(value) ===
            String(selected)
          );
        }
      );
    });
  };

  /*
   * -------------------------------------------------------
   * Update button availability
   * -------------------------------------------------------
   */

  const updateAvailability = () => {

    groups.forEach(group => {

      const optionIndex =
        Number(group.dataset.optionIndex);

      group
        .querySelectorAll("[data-option-value]")
        .forEach(button => {

          const value =
            button.dataset.optionValue;

          const available =
            isOptionAvailable(
              optionIndex,
              value
            );

          const selected =
            String(selectedOptions[optionIndex]) ===
            String(value);

          /*
           * Don't disable selected button
           */
          const disabled =
            !available && !selected;

          button.disabled = disabled;

          button.classList.toggle(
            "is-unavailable",
            disabled
          );
        });
    });
  };

  /*
   * -------------------------------------------------------
   * Main variant update
   * -------------------------------------------------------
   */

  const updateVariant = () => {

    const variant = findVariant();

    /*
     * Always update UI first
     */
    syncButtons();
    updateAvailability();

    /*
     * Valid variant found
     */
    if (variant) {

      currentVariant = variant;

      /*
       * THIS IS THE IMPORTANT PART
       *
       * Update Shopify product form variant ID
       */
      if (hiddenId) {
        hiddenId.value = String(variant.id);
      }

      /*
       * Also store it on form
       */
      form.dataset.variantId =
        String(variant.id);

      /*
       * Update price
       */
      if (priceEl) {
        priceEl.textContent =
          money(variant.price);
      }

      /*
       * Availability
       */
      if (statusEl) {
        statusEl.textContent =
          variant.available
            ? "READY TO ADD."
            : "SOLD OUT.";
      }

      /*
       * Add to cart
       */
      if (addBtn) {
        addBtn.disabled =
          !variant.available;
      }

      /*
       * DEBUG
       */
      console.log(
        "VARIANT CHANGED:",
        {
          id: variant.id,
          title: variant.title,
          options: variant.options
        }
      );

      return;
    }

    /*
     * No complete variant yet
     */
    if (statusEl) {

      const allSelected =
        selectedOptions.length === groups.length &&
        selectedOptions.every(
          value =>
            value !== null &&
            value !== undefined &&
            value !== ""
        );

      statusEl.textContent =
        allSelected
          ? "THIS COMBINATION IS NOT AVAILABLE."
          : "SELECT AN AVAILABLE OPTION.";
    }

    if (addBtn) {
      addBtn.disabled = true;
    }
  };

  /*
   * -------------------------------------------------------
   * BUTTON CLICK
   * -------------------------------------------------------
   */

  groups.forEach(group => {

    const optionIndex =
      Number(group.dataset.optionIndex);

    group
      .querySelectorAll("[data-option-value]")
      .forEach(button => {

        button.addEventListener(
          "click",
          event => {

            event.preventDefault();

            const value =
              button.dataset.optionValue;

            console.log(
              "OPTION CLICKED:",
              {
                optionIndex,
                value
              }
            );

            /*
             * Set selected option
             */
            selectedOptions[optionIndex] =
              value;

            /*
             * If user changes Color,
             * check whether current Size is still valid.
             *
             * If not, clear the Size selection.
             */
            for (
              let i = optionIndex + 1;
              i < groups.length;
              i++
            ) {

              const existingValue =
                selectedOptions[i];

              if (
                existingValue === null ||
                existingValue === undefined ||
                existingValue === ""
              ) {
                continue;
              }

              const combinationExists =
                variants.some(variant => {

                  if (!variant.available) {
                    return false;
                  }

                  const options =
                    getVariantOptions(variant);

                  return selectedOptions.every(
                    (selectedValue, selectedIndex) => {

                      if (
                        selectedValue === null ||
                        selectedValue === undefined ||
                        selectedValue === ""
                      ) {
                        return true;
                      }

                      return (
                        String(
                          options[selectedIndex]
                        ) ===
                        String(selectedValue)
                      );
                    }
                  );
                });

              if (!combinationExists) {
                selectedOptions[i] = "";
              }
            }

            /*
             * Update everything
             */
            updateVariant();
          }
        );
      });
  });

  /*
   * Initial variant state
   */
  updateVariant();

});

  // Quantity stepper
  document.querySelectorAll(".quantity-stepper").forEach(stepper=>{
    const input=stepper.querySelector("[data-quantity-input]");
    const set=(value)=>{input.value=Math.max(1,parseInt(value||1,10)||1);};
    stepper.querySelector("[data-qty-minus]")?.addEventListener("click",()=>set(Number(input.value)-1));
    stepper.querySelector("[data-qty-plus]")?.addEventListener("click",()=>set(Number(input.value)+1));
    input?.addEventListener("change",()=>set(input.value));
  });

  // Cart page quantity steppers
  document.querySelectorAll("[data-cart-qty-minus], [data-cart-qty-plus]").forEach(button=>{
    button.addEventListener("click",()=>{
      const input=button.closest(".bag-item")?.querySelector("input[name=\"updates[]\"]");
      if(!input) return;
      const delta=button.hasAttribute("data-cart-qty-plus")?1:-1;
      input.value=Math.max(0,(parseInt(input.value||0,10)||0)+delta);
    });
  });

  // Size chart modal
  const sizeModal=document.querySelector("[data-size-chart-modal]");
  const openSize=()=>{sizeModal?.classList.add("is-open");sizeModal?.setAttribute("aria-hidden","false");document.body.classList.add("size-chart-open");};
  const closeSize=()=>{sizeModal?.classList.remove("is-open");sizeModal?.setAttribute("aria-hidden","true");document.body.classList.remove("size-chart-open");};
  document.querySelectorAll("[data-size-chart-open]").forEach(btn=>btn.addEventListener("click",openSize));
  document.querySelectorAll("[data-size-chart-close]").forEach(btn=>btn.addEventListener("click",closeSize));
  document.addEventListener("keydown",e=>{if(e.key==="Escape") closeSize();});

  document.addEventListener("mousemove",event=>{
    const mark=document.querySelector(".kinetic-lockup");
    if(mark&&window.innerWidth>760){
      const x=(event.clientX/window.innerWidth-.5)*5;
      const y=(event.clientY/window.innerHeight-.5)*3;
      mark.style.transform=`rotate(-5deg) translate(${x}px,${y}px)`;
    }
  });
});
